"use strict";
// (C) 2019-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = void 0;
var EMAIL_REGEX = 
// disabling as there are issues with the regex but we rather not touch it...
// eslint-disable-next-line
/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function isEmail(value) {
    return EMAIL_REGEX.test(value);
}
exports.isEmail = isEmail;
//# sourceMappingURL=validate.js.map